import { alpha } from '@mui/material';

const styles = {
  card: {
    textAlign: 'center',
    backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.15),
  },
  flexCard: {
    textAlign: 'center',
    backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.15),
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
  },
  button: {
    height: '100%',
    whiteSpace: 'nowrap',
  },
  chart: {
    height: 350,
  },
  chartSlot: {
    legend: {
      hidden: true,
    },
  },
  chartMargin: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
  },
  legendContainer: {
    maxHeight: 250,
    overflowY: 'auto',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    ml: 2,
  },
  legendBox: {
    width: 20,
    height: 20,
    flexShrink: 0,
  },
  loader: {
    zIndex: (theme) => theme.zIndex.modal + 1,
    color: 'primary.white',
    backdropFilter: 'blur(2px)',
    transition: 'opacity 0.3s ease-in-out',
  },
};

export default styles;
